import { SET_SCREEN } from '../constants';
import SCREENS from '../../helpers/screens';

export const initialState = SCREENS.WELCOME__SCREEN;

export default (state = initialState, { type, payload }) => (type === SET_SCREEN ? payload.screen : state);
